import gql from "graphql-tag";

const imageFields = `id
  alternativeText
  url
  formats
`;

export const GET_PRESSROOM_DATA = gql`
  query GET_PRESSROOM_DATA($limit: Int, $tag: String, $start: Int, $countryCode: String) {
    pressroomArticlesConnection(where: { countries: { twoLetterCode: $countryCode }, published: true, filterTags: { tag: $tag } }) {
      aggregate {
        count
      }
    }
   articles: pressroomArticles (
      where: { countries: { twoLetterCode: $countryCode }, published: true, filterTags: { tag: $tag } }
      sort: "publicationDate:desc"
      limit: $limit,
      start: $start
    ) {
      id
      title
      publicationDate
      slug
      link
      meta{
        id
        seo{
          id
          description
          keywords
          thumbnail{
            ${imageFields}
          }
        }
      }
      header {
        id
        h1
        author
        heroImage {
          ${imageFields}
        }
        content
      }
      filterTags {
        id
        tag
      }
      blogContent {
        __typename
        ... on ComponentBlogTextBlock {
          id
          richText
        }
        ... on ComponentBlogTextImage {
          id
          Content
          Image {
            ${imageFields}
          }
        }
        ... on ComponentBlogTwoColumns {
          id
          left
          right
        }
        ... on ComponentBlogImageText {
          id
          Image {
            ${imageFields}
          }
          Content
        }
        ... on ComponentBlogReactComponent {
          id
          name
        }
        ... on ComponentBlogWideImage {
          id
          imageWide {
            ${imageFields}
          }
        }
        ... on ComponentBlogVideo {
          id
          title
          video_text
          video {
            url
          }
        }
        ... on ComponentBlogCaption {
          id
          caption
        }
      }
    }
  }
`;
